var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.page,{tag:"Component",attrs:{"doctor-id":_vm.doctorId,"clinics":_vm.clinics,"specializations":_vm.specializations},on:{"update:doctorId":function($event){_vm.doctorId=$event},"update:doctor-id":function($event){_vm.doctorId=$event}}})}
var staticRenderFns = []

export { render, staticRenderFns }